import React, { useEffect, useState } from 'react';
import store, { searchActions } from '@apply/adminStore';
import { SectionHeader, BfiCustomStore } from '../common/SharedComponents';
import BorrowersTable from './tables/BorrowersTable';
import debounce from 'lodash.debounce';
import { BorrowerModals } from './common/BorrowerComponents';
import { LoanStatusType } from '@apply/constants';
import { ActionType, LinkType } from './common/BorrowerConstants';
import { executeAction } from './common/BorrowerFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function ActiveBorrowersLanding() {
    const searchState = useSelector((state) => state.searchState);
    const navigate = useNavigate();
    const { dispatch } = store;
    const [loanStatusId, set_loanStatusId] = useState(LoanStatusType.Outstanding);
    const [showDollars, set_showDollars] = useState(false);
    const gridStore1 = new BfiCustomStore();
    const debouncedSearch = debounce(dispatch, 500);

    const _onSearchChange = (event) => {
        debouncedSearch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    borrower: event.target.value,
                },
            })
        );
    };

    useEffect(() => {
        return () => {
            //Cancel any further searches if component is unloaded
            debouncedSearch.cancel();
        };
    }, []);

    const setShowAmounts = (show) => {
        if (show === '1') {
            set_showDollars(true);
        } else {
            set_showDollars(false);
        }
    };

    const onAddBusiness = () => {
        var model = {
            actionId: ActionType.EditCompany,
            companyId: 0,
            linkType: LinkType.Company,
        };
        executeAction(model, navigate);
    };

    return (
        <>
            <SectionHeader
                title='Clients - By Business'
                buttonText='Add Business'
                buttonCallback={onAddBusiness}
            />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4', height: '100%' }}
            >
                <div className='input-has-icon main-search2'>
                    <div>
                        <input
                            type='search'
                            placeholder='Search on Business, Borrower or Principal Name...'
                            defaultValue={searchState?.searchText?.borrower}
                            onChange={(event) => _onSearchChange(event)}
                        />
                        <FontAwesomeIcon
                            icon={faSearch}
                            aria-hidden='true'
                            className='icon'
                        />
                    </div>
                </div>
                <div className='main-search2'>
                    <select
                        id='loanStatusId'
                        value={loanStatusId}
                        onChange={(e) => set_loanStatusId(parseInt(e.target.value))}
                    >
                        <option value='0'>Approved Loans</option>
                        <option value='1'>Outstanding Loans</option>
                        <option value='2'>Repaid Loans</option>
                    </select>
                </div>
                <div
                    className='main-search2'
                    style={{ lineHeight: '40px', paddingTop: '10px' }}
                >
                    Totals:&nbsp;&nbsp;&nbsp;
                    <input
                        type='radio'
                        value='0'
                        name={`showAmounts`}
                        checked={!showDollars}
                        onChange={(e) => setShowAmounts(e.target.value)}
                    />
                    <label
                        style={{ fontSize: '12px' }}
                        htmlFor='showAmounts'
                    >
                        Count
                    </label>
                    <input
                        type='radio'
                        value='1'
                        name={`showAmounts`}
                        checked={showDollars}
                        onChange={(e) => setShowAmounts(e.target.value)}
                    />
                    <label
                        style={{ fontSize: '12px' }}
                        htmlFor='showAmounts'
                    >
                        Dollars (1000s)
                    </label>
                </div>
                <div
                    className='scrollable-content'
                    style={{ padding: '.5rem', height: 'calc(100vh - 190px)' }}
                >
                    <BorrowersTable
                        gridStore={gridStore1}
                        loanStatusId={loanStatusId}
                        showDollars={showDollars}
                    />
                </div>
            </div>
            <BorrowerModals />
        </>
    );
}

export default ActiveBorrowersLanding;
